import { render, staticRenderFns } from "./splitPageRoot.vue?vue&type=template&id=4fb18c46&"
import script from "./splitPageRoot.vue?vue&type=script&lang=js&"
export * from "./splitPageRoot.vue?vue&type=script&lang=js&"
import style0 from "./splitPageRoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "splitPageRoot.vue"
export default component.exports